import { render, staticRenderFns } from "./TwoSidesSwitch.vue?vue&type=template&id=34c6287e&scoped=true"
import script from "./TwoSidesSwitch.vue?vue&type=script&lang=js"
export * from "./TwoSidesSwitch.vue?vue&type=script&lang=js"
import style0 from "./TwoSidesSwitch.vue?vue&type=style&index=0&id=34c6287e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c6287e",
  null
  
)

export default component.exports